import { useFormContext } from "react-hook-form";
import { FieldValidator } from "./Form"
import textData from "../../textData.json";
import { useContext } from "react";
import { LangContext, LangContextType } from "../../utilities/customHooks";
import { Checkbox } from "@components/ui/checkbox";
import { Label } from "@components/ui/label";
import parseStringToHTML from "html-react-parser";

export default function CheckboxWithText(
  {
    text,
    name,
    value,
    setValue,
    disabled,
    readOnly,
    validator,
    htmlLabel,
  }
  :
  {
    text?: string, // text explaination besides the checkbox
    name: string,
    value: boolean,
    setValue: (key: string, value: boolean) => void,
    disabled?: boolean,
    readOnly?: boolean,
    validator?: FieldValidator,
    // Opt-in: parse `text` as HTML. Only pass this for trusted, developer-authored
    // template labels (e.g. the ToS label with an <a>). NEVER enable it for
    // DB-derived / user-entered values — html-react-parser is not XSS-safe.
    htmlLabel?: boolean,
  }
) {
  const { langState } = useContext(LangContext) as LangContextType
  const { register } = useFormContext();

  return (
    <>
      {/* Hidden input for react-hook-form registration/validation.
          We register ONLY the custom `validate` closure (which reads the real
          `value` prop). Spreading `...validator` here would forward the template's
          `required` rule, which RHF evaluates against the hidden input's own value
          (always "") and thus fails on every submit, checked or not — blocking the
          form permanently. */}
      <input
        type="hidden"
        {...register(name, {
          validate: () => {
            if (validator?.required && !value) {
              return textData.Components.Form.CheckboxWithText.Required[langState]
            }
            return true;
          }
        })}
      />
      <div className='flex items-center gap-2 my-1.5'>
        <Checkbox
          id={name}
          checked={value}
          disabled={disabled || readOnly}
          onCheckedChange={() => setValue(name, !value)}
          onKeyDown={(e) => { if (e.key === "Enter") setValue(name, !value) }}
        />
        {text && (
          <Label htmlFor={name} className="text-base font-normal cursor-pointer">
            {htmlLabel ? parseStringToHTML(text) : text}
          </Label>
        )}
      </div>
    </>
  )
}
